import { render, staticRenderFns } from "./BranchTimeEdit.vue?vue&type=template&id=d997adbe&scoped=true&"
import script from "./BranchTimeEdit.vue?vue&type=script&lang=js&"
export * from "./BranchTimeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d997adbe",
  null
  
)

export default component.exports